<template>
    <vxe-modal
        v-model="visible"
        title="数字员工类型变更审核"
        :width="860"
        :height="560"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <vxe-form
                :data="formData"
                :rules="formRules"
                title-align="right"
                ref="rFormChange"
                title-width="60"
            >
                <vxe-form-item
                    title="开发编号"
                    field="ProcessID"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formData.ProcessID"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="数字员工名称"
                    field="ProcessName"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formData.ProcessName"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="原数字员工类型"
                    field="oldempType"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formData.oldempType"
                            :options="digitalTypes"
                            disabled
                        ></vxe-select>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="新数字员工类型"
                    field="empType"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formData.empType"
                            :options="digitalTypes"
                            placeholder="请选择新数字员工类型"
                            :disabled="allInputDisable"
                        ></vxe-select>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="变更原因"
                    field="changeReason"
                    span="24"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-textarea
                            rows="4"
                            v-model="formData.changeReason"
                            placeholder="请输入变更原因"
                            maxlength="1000"
                            show-word-count
                            :disabled="allInputDisable"
                        ></vxe-textarea>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="附件"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-paperclip' }"
                ></vxe-form-item>
                <vxe-form-item
                    title="附件"
                    field="fAttachment"
                    span="18"
                    :item-render="{}"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formData.fAttachment"
                            placeholder="请选择附件"
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <template #default="">
                        <vxe-button @click="insertAttachment" disabled
                            >浏览</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <a
                        v-if="isShowAttachmentLink"
                        href="javascript:void(0);"
                        @click="downloadFile(10)"
                        >下载</a
                    >
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                </vxe-form-item>
                <vxe-form-item
                    span="24"
                    title-align="left"
                    title-width="600px"
                    :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                >
                    <template #title>
                        <span style="color: red">审核意见</span>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="24">
                    <template #default>
                        <vxe-textarea
                            rows="4"
                            v-model="auditOpinion"
                            placeholder="请输入审核意见"
                            maxlength="1000"
                            show-word-count
                        ></vxe-textarea>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
        <template #footer>
            <div align="center" span="24">
                <vxe-button
                    @click="reject"
                    icon="fa fa-close"
                    status="danger"
                >
                    驳回
                </vxe-button>

                <vxe-button
                    :loading="submitting"
                    @click="submit"
                    icon="fa fa-check"
                    status="success"
                >
                    通过
                </vxe-button>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal
        title="审核记录"
        v-model="isShowAuditList"
        width="500"
        height="600"
    >
        <template #default>
            <div>
                <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import MyAuditLine from "../myPlug/MyAuditLine";
import {
    ref,
    reactive,
    defineExpose,
    defineEmits,
    defineProps,
    getCurrentInstance,
} from "vue";
const { proxy } = getCurrentInstance();
import { VXETable } from "vxe-table";
import Qs from "qs";
const auditOpinion = ref("OK");
const props = defineProps({
    digitalTypes: {
        type: Array,
        default: () => [
            { label: "作业型", value: "L01" },
            { label: "助手型", value: "L02" },
            { label: "专家型", value: "L03" },
        ],
    },
});
const dtAudit = ref([]);
const isShowAuditList = ref(false);
let oneAttachment = ref({}); //上传的附件
let isShowAttachmentLink = ref(true);
const emit = defineEmits(["flashPubList"]);

const activeKey = ref("1");
const submitting = ref(false);
const allInputDisable = ref(true);
const rFormChange = ref();
const historyData = ref([]);

const formData = reactive(getEmptyFormData());

const formRules = {
    empType: [{ required: true, message: "请选择新数字员工类型" }],
    changeReason: [{ required: true, message: "请输入变更原因" }],
};
const visible = ref(false);

function getEmptyFormData() {
    return {
        Id: "",
        pubId: "",

        ProcessID: "",
        ProcessName: "",
        DevelopUser: "",

        empType: "",
        oldempType: "",

        changeType: "2",
        status: "0",
        changeReason: "",
        creationTime: "",
        creator: "",
        fAttachment: null,
    };
}

const downloadFile = (type) => {
    proxy.$api.fileManageAPI
        .downloadPublishFile(
            Qs.stringify({
                publishId: formData.Id,
                type: type,
            }),
            {
                responseType: "blob",
            }
        )
        .then((res) => {
            const contentType = res.headers["content-type"] || "";

            // 如果后端返回的是 JSON，说明是错误信息
            if (contentType.includes("application/json")) {
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        const result = JSON.parse(reader.result);

                        VXETable.modal.alert({
                            content:
                                result.Message || result.message || "下载失败",
                            status: "error",
                        });
                    } catch (e) {
                        VXETable.modal.alert({
                            content: "下载失败",
                            status: "error",
                        });
                    }
                };

                reader.readAsText(res.data);
                return;
            }

            let fileName = "下载文件";

            const disposition =
                res.headers["content-disposition"] ||
                res.headers["Content-Disposition"];

            if (disposition) {
                const utf8Match = disposition.match(
                    /filename\*=UTF-8''([^;]+)/i
                );
                const normalMatch = disposition.match(/filename="?([^"]+)"?/i);

                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else if (normalMatch && normalMatch[1]) {
                    fileName = decodeURIComponent(normalMatch[1]);
                }
            }

            const blob = new Blob([res.data], {
                type: contentType || "application/octet-stream",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.log(error);

            VXETable.modal.alert({
                content: "文件下载失败",
                status: "error",
            });
        });
};

async function reject() {
    if (auditOpinion.value === "OK") {
        VXETable.modal.message({
            content: "驳回请修改默认审核意见",
            status: "error",
        });
        return;
    }
    const type = await VXETable.modal.confirm("您确定要驳回吗?");

    if (type === "confirm") {
        const params = {
            Id: formData.Id,
            status: "3", //驳回 改回已审核
            auditMan: proxy.$store.state.userID,
        };
        proxy.$api.newPublishManageAPI
            .auditPublishInfoChange(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                const auditNode = "CoE审核";
                //审核记录
                addAuditRecord(formData.Id, "2", auditNode, auditOpinion.value);

                VXETable.modal.message({
                    content: "驳回成功",
                    status: "success",
                });
                visible.value = false;
                emit("flashData");
            })
            .catch((error) => {
                console.log(error);
            });
    }
}
function submit() {
    if (auditOpinion.value === "") {
        VXETable.modal.message({
            content: "审核意见不能为空",
            status: "error",
        });
        return;
    }

    const params = {
        Id: formData.Id,
        status: "2",
        auditMan: proxy.$store.state.userID,
    };
    proxy.$api.newPublishManageAPI
        .auditPublishInfoChange(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }

            const auditNode = "CoE审核";
            //审核记录
            addAuditRecord(formData.Id, "1", auditNode, auditOpinion.value);

            VXETable.modal.message({
                content: "审核成功",
                status: "success",
            });
            visible.value = false;
            emit("flashData");
        })
        .catch((error) => {
            console.log(error);
        });
}
const insertAttachment = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        formData.fAttachment = file.name;
        oneAttachment.value = file;
    });
};
function audit(row) {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 1,
        searchKey: [row.Id],
    };
    proxy.$api.newPublishManageAPI
        .getPublishInfoChangeOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            Object.assign(formData, res.data.Data);

            visible.value = true;
        })
        .catch((error) => {
            console.log(error);
        });
}

function setHistory(row) {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 50,
        searchKey: [row.Id, "2"],
    };
    proxy.$api.newPublishManageAPI
        .getPublishInfoChangeOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            // console.log(res.data.Data);
            historyData.value = Array.isArray(res.data.Data.dataTable)
                ? res.data.Data.dataTable
                : [];
        })
        .catch((error) => {
            console.log(error);
        });
}
const getModel = () => {
    const data = new FormData();
    data.append("fileAttachment", oneAttachment.value);
    data.append("Id", formData.Id);
    data.append("pubId", formData.pubId);
    data.append("fAttachment", formData.fAttachment);
    data.append("empType", formData.empType);
    data.append("oldempType", formData.oldempType);
    data.append("status", formData.status);
    data.append("creator", formData.creator);
    data.append("changeReason", formData.changeReason);
    data.append("changeType", formData.changeType);
    return data;
};

const addAuditRecord = (bussId, status, auditNode, auditOpinion) => {
    //写审核日志
    const params = {
        auditBuId: bussId,
        auditMan: proxy.$store.state.userName,
        auditManUid: proxy.$store.state.userID,
        auditStatus: status, //1 通过 2 驳回
        auditOpinion: auditOpinion,
        auditNode: auditNode,
    };
    proxy.$api.requireManageAPI
        .addAuditRecord(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
defineExpose({
    audit,
});
</script>

<style scoped>
.apply-page {
    padding: 16px;
    background: #fff;
}

.notice-text {
    color: red;
}
</style>
